import React, { useEffect, useRef, useState } from 'react'
import Main from '../Main'
import { Col, Row } from 'react-bootstrap'
import '../../assets/css/dashboard.scss'
import totalSla from '../../assets/images/Sla/totalSla.svg'
import inProcess from '../../assets/images/Sla/slaInProcess.svg'
import hold from '../../assets/images/Sla/slaHold.svg'
import completed from '../../assets/images/Sla/slaCompleted.svg'
import Download from '../MainSection/Download/Download'
import RelationshipTypeChart from '../Graphs/RelationshipTypeChart'
import FunnelChart from '../Graphs/FunnelChart'
import AttendanceStatusChart from '../Graphs/AttendanceStatusChart'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { loadAssignedToSlaTypeDropdownData, loadCompanyDropdownData, loadReportingToDropdownData, loadSLADashboardAssignedScoreData, loadSLADashboardCardData, loadSLADashboardChecklistStatusChartData, loadSLADashboardSlaTypesChartData, loadSLADashboardSlaTypeStatusChartData, loadUserDropdownData } from '../../redux/action'
import Skeleton from 'react-loading-skeleton'

function ServiceLevelAgreementDashboard() {
    let dispatch = useDispatch();
    const navigate = useNavigate();

    const signInDetails = JSON.parse(sessionStorage.getItem('SignInDetails'));
    const storedCompanyId = signInDetails ? signInDetails[0].CompanyID : null
    const storedCompanyName = signInDetails ? signInDetails[0].CompanyName : null

    const { getCompanyDropdown } = useSelector((state) => state.data);
    const { reportingToDropdown } = useSelector((state) => state.data);
    const { getUserDropdown } = useSelector((state) => state.data);
    const { assignedToSlaTypeDropdownData } = useSelector((state) => state.data);
    const { getSlaDashboardCardData } = useSelector((state) => state.data);
    const { getSlaDashboardSlaTypeStatusChartData } = useSelector((state) => state.data);
    const { getSlaDashboardSlaTypesChartData } = useSelector((state) => state.data);
    const { getSlaDashboardChecklistStatusChartData } = useSelector((state) => state.data);

    const currentYear = new Date().getFullYear();
    const [loading, setLoading] = useState(true);
    const [selectedOptionForSlaType, setSelectedOptionForSlaType] = useState({
        // company: storedCompanyId || 'Company Name',
        company: { id: storedCompanyId, name: storedCompanyName },
        assignedTo: null,
        assignedToId: null,
        slaType: null,
        slaTypeId: null,
        year: currentYear || 'Year'
    });
    const [selectedOptionForSlaTypeStatus, setSelectedOptionForSlaTypeStatus] = useState({
        // company: storedCompanyId || 'Company Name',
        company: { id: storedCompanyId, name: storedCompanyName },
        assignedTo: null,
        assignedToId: null,
        slaType: null,
        slaTypeId: null,
        year: currentYear || 'Year'
    });
    const [selectedOptionForSlaChecklistStatus, setSelectedOptionForSlaChecklistStatus] = useState({
        // company: storedCompanyId || 'Company Name',
        company: { id: storedCompanyId, name: storedCompanyName },
        assignedTo: null,
        assignedToId: null,
        slaType: null,
        slaTypeId: null,
        year: currentYear || 'Year'
    });

    useEffect(() => {
        dispatch(loadCompanyDropdownData());
        dispatch(loadReportingToDropdownData());
        dispatch(loadUserDropdownData());
        dispatch(loadAssignedToSlaTypeDropdownData());
        dispatch(loadSLADashboardCardData(setLoading))
    }, []);

    useEffect(() => {
        if (selectedOptionForSlaTypeStatus.company && selectedOptionForSlaTypeStatus.year) {
            // Dispatch action with selectedOption (including companyId and year)
            dispatch(loadSLADashboardSlaTypeStatusChartData(selectedOptionForSlaTypeStatus.company.id, selectedOptionForSlaTypeStatus.assignedToId, selectedOptionForSlaTypeStatus.slaTypeId, selectedOptionForSlaTypeStatus.year));
        }
    }, [selectedOptionForSlaTypeStatus, dispatch]);

    useEffect(() => {
        if (selectedOptionForSlaType.company && selectedOptionForSlaType.year) {
            // Dispatch action with selectedOption (including companyId and year)
            dispatch(loadSLADashboardSlaTypesChartData(selectedOptionForSlaType.company.id, selectedOptionForSlaType.assignedToId, selectedOptionForSlaType.slaTypeId, selectedOptionForSlaType.year));
        }
    }, [selectedOptionForSlaType, dispatch]);

    useEffect(() => {
        if (selectedOptionForSlaChecklistStatus.company && selectedOptionForSlaChecklistStatus.year) {
            // Dispatch action with selectedOption (including companyId and year)
            dispatch(loadSLADashboardChecklistStatusChartData(selectedOptionForSlaChecklistStatus.company.id, selectedOptionForSlaChecklistStatus.assignedToId, selectedOptionForSlaChecklistStatus.slaTypeId, selectedOptionForSlaChecklistStatus.year));
        }
    }, [selectedOptionForSlaChecklistStatus, dispatch]);

    // Function to generate an array of years from 2020 to current year
    function generateYearRange(startYear) {
        const currentYear = new Date().getFullYear();  // Get current year dynamically
        const years = [];

        // Generate years from startYear to currentYear
        for (let year = startYear; year <= currentYear; year++) {
            years.push({ value: year, label: year });
        }

        return years;
    }

    const handleSelect = (eventKey, type, graphType) => {
        let selectedOption = null;

        if (graphType === 'SlaTypesStatus' || graphType === 'SlaTypes' || graphType === 'SlaChecklistStatus') {
            let dropdownData;
            let stateSetter;

            if (graphType === 'SlaTypesStatus') {
                dropdownData = type === 'company' ? getCompanyDropdown :
                    type === 'assignedTo' ? getUserDropdown :
                        type === 'slaType' ? assignedToSlaTypeDropdownData :
                            type === 'year' ? dropdownOptions.year.items : [];
                stateSetter = setSelectedOptionForSlaTypeStatus;
            } else if (graphType === 'SlaTypes') {
                dropdownData = type === 'company' ? getCompanyDropdown :
                    type === 'assignedTo' ? getUserDropdown :
                        type === 'slaType' ? assignedToSlaTypeDropdownData :
                            type === 'year' ? dropdownOptions.year.items : [];
                stateSetter = setSelectedOptionForSlaType;
            } else if (graphType === 'SlaChecklistStatus') {
                dropdownData = type === 'company' ? getCompanyDropdown :
                    type === 'assignedTo' ? getUserDropdown :
                        type === 'slaType' ? assignedToSlaTypeDropdownData :
                            type === 'year' ? dropdownOptions.year.items : [];
                stateSetter = setSelectedOptionForSlaChecklistStatus;
            }

            // Find the selected option
            if (dropdownData && dropdownData.length > 0) {
                selectedOption = dropdownData.find(item => item.value === Number(eventKey)); // Convert to number
            }

            if (selectedOption) {
                // Update state with the selected option
                const updateData = { ...selectedOption };

                if (type === 'company') {
                    stateSetter(prev => ({
                        ...prev,
                        company: { id: selectedOption.value, name: selectedOption.label }
                    }));
                } else if (type === 'assignedTo') {
                    stateSetter(prev => ({
                        ...prev,
                        assignedTo: selectedOption.label,
                        assignedToId: selectedOption.value
                    }));
                } else if (type === 'slaType') {
                    stateSetter(prev => ({
                        ...prev,
                        slaType: selectedOption.label,
                        slaTypeId: selectedOption.value
                    }));
                } else if (type === 'year') {
                    stateSetter(prev => ({
                        ...prev,
                        year: selectedOption.value
                    }));
                }
            } else {
                console.log(`No ${type} found matching the eventKey`);
            }
        }
    };


    const labels = ['Below < 40%', '40 - 70%', 'Above > 70%'];
    const colors = [
        'rgba(255, 94, 94, 1)',  // High
        'rgba(255, 159, 0, 1)',  // Medium
        'rgba(58, 201, 119, 1)', // Low
    ];
    const data = [30, 40, 50];

    const ComplaintLabels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const datasets = [
        {
            type: 'bar',
            label: 'Hold',
            data: [getSlaDashboardSlaTypeStatusChartData?.JanOnHold,
            getSlaDashboardSlaTypeStatusChartData?.FebOnHold,
            getSlaDashboardSlaTypeStatusChartData?.MarOnHold,
            getSlaDashboardSlaTypeStatusChartData?.AprOnHold,
            getSlaDashboardSlaTypeStatusChartData?.MayOnHold,
            getSlaDashboardSlaTypeStatusChartData?.JunOnHold,
            getSlaDashboardSlaTypeStatusChartData?.JulOnHold,
            getSlaDashboardSlaTypeStatusChartData?.AugOnHold,
            getSlaDashboardSlaTypeStatusChartData?.SepOnHold,
            getSlaDashboardSlaTypeStatusChartData?.OctOnHold,
            getSlaDashboardSlaTypeStatusChartData?.NovOnHold,
            getSlaDashboardSlaTypeStatusChartData?.DecOnHold
            ],
            backgroundColor: 'rgba(240, 207, 43, 1)', // Yellow
            borderColor: 'rgba(240, 207, 43, 1)',
            borderWidth: 1,
            borderRadius: 4,
            barThickness: 8,
            borderSkipped: false,
        },
        {
            type: 'bar',
            label: 'Inprogress',
            data: [getSlaDashboardSlaTypeStatusChartData?.JanInProcess,
            getSlaDashboardSlaTypeStatusChartData?.FebInProcess,
            getSlaDashboardSlaTypeStatusChartData?.MarInProcess,
            getSlaDashboardSlaTypeStatusChartData?.AprInProcess,
            getSlaDashboardSlaTypeStatusChartData?.MayInProcess,
            getSlaDashboardSlaTypeStatusChartData?.JunInProcess,
            getSlaDashboardSlaTypeStatusChartData?.JulInProcess,
            getSlaDashboardSlaTypeStatusChartData?.AugInProcess,
            getSlaDashboardSlaTypeStatusChartData?.SepInProcess,
            getSlaDashboardSlaTypeStatusChartData?.OctInProcess,
            getSlaDashboardSlaTypeStatusChartData?.NovInProcess,
            getSlaDashboardSlaTypeStatusChartData?.DecInProcess
            ],
            backgroundColor: 'rgba(255, 94, 0, 1)', // Orange
            borderColor: 'rgba(255, 94, 0, 1)',
            borderWidth: 1,
            borderRadius: 4,
            barThickness: 8,
            borderSkipped: false,
        },
        {
            type: 'line',
            label: 'Completed',
            data: [getSlaDashboardSlaTypeStatusChartData?.JanCompleted,
            getSlaDashboardSlaTypeStatusChartData?.FebCompleted,
            getSlaDashboardSlaTypeStatusChartData?.MarCompleted,
            getSlaDashboardSlaTypeStatusChartData?.AprCompleted,
            getSlaDashboardSlaTypeStatusChartData?.MayCompleted,
            getSlaDashboardSlaTypeStatusChartData?.JunCompleted,
            getSlaDashboardSlaTypeStatusChartData?.JulCompleted,
            getSlaDashboardSlaTypeStatusChartData?.AugCompleted,
            getSlaDashboardSlaTypeStatusChartData?.SepCompleted,
            getSlaDashboardSlaTypeStatusChartData?.OctCompleted,
            getSlaDashboardSlaTypeStatusChartData?.NovCompleted,
            getSlaDashboardSlaTypeStatusChartData?.DecCompleted
            ],
            backgroundColor: (context) => {
                const chart = context.chart;
                const ctx = chart.ctx;
                const gradient = ctx.createLinearGradient(0, 0, 0, chart.height);
                gradient.addColorStop(0, 'rgba(58, 201, 119, 0.2)');
                gradient.addColorStop(1, 'rgba(58, 201, 119, 0)');
                return gradient;
            },
            borderColor: 'rgba(58, 201, 119, 1)',
            borderWidth: 2,
            fill: true,
            tension: 0.4,
        },

    ];

    const datasetsOfSlaChecklistStatus = [
        {
            type: 'bar',
            label: 'Hold',
            data: [getSlaDashboardChecklistStatusChartData?.JanOnHold,
            getSlaDashboardChecklistStatusChartData?.FebOnHold,
            getSlaDashboardChecklistStatusChartData?.MarOnHold,
            getSlaDashboardChecklistStatusChartData?.AprOnHold,
            getSlaDashboardChecklistStatusChartData?.MayOnHold,
            getSlaDashboardChecklistStatusChartData?.JunOnHold,
            getSlaDashboardChecklistStatusChartData?.JulOnHold,
            getSlaDashboardChecklistStatusChartData?.AugOnHold,
            getSlaDashboardChecklistStatusChartData?.SepOnHold,
            getSlaDashboardChecklistStatusChartData?.OctOnHold,
            getSlaDashboardChecklistStatusChartData?.NovOnHold,
            getSlaDashboardChecklistStatusChartData?.DecOnHold
            ],
            backgroundColor: 'rgba(240, 207, 43, 1)', // Yellow
            borderColor: 'rgba(240, 207, 43, 1)',
            borderWidth: 1,
            borderRadius: 4,
            barThickness: 8,
            borderSkipped: false,
        },
        {
            type: 'bar',
            label: 'Inprogress',
            data: [getSlaDashboardChecklistStatusChartData?.JanInProcess,
            getSlaDashboardChecklistStatusChartData?.FebInProcess,
            getSlaDashboardChecklistStatusChartData?.MarInProcess,
            getSlaDashboardChecklistStatusChartData?.AprInProcess,
            getSlaDashboardChecklistStatusChartData?.MayInProcess,
            getSlaDashboardChecklistStatusChartData?.JunInProcess,
            getSlaDashboardChecklistStatusChartData?.JulInProcess,
            getSlaDashboardChecklistStatusChartData?.AugInProcess,
            getSlaDashboardChecklistStatusChartData?.SepInProcess,
            getSlaDashboardChecklistStatusChartData?.OctInProcess,
            getSlaDashboardChecklistStatusChartData?.NovInProcess,
            getSlaDashboardChecklistStatusChartData?.DecInProcess
            ],
            backgroundColor: 'rgba(255, 94, 0, 1)', // Orange
            borderColor: 'rgba(255, 94, 0, 1)',
            borderWidth: 1,
            borderRadius: 4,
            barThickness: 8,
            borderSkipped: false,
        },
        {
            type: 'line',
            label: 'Completed',
            data: [getSlaDashboardChecklistStatusChartData?.JanCompleted,
            getSlaDashboardChecklistStatusChartData?.FebCompleted,
            getSlaDashboardChecklistStatusChartData?.MarCompleted,
            getSlaDashboardChecklistStatusChartData?.AprCompleted,
            getSlaDashboardChecklistStatusChartData?.MayCompleted,
            getSlaDashboardChecklistStatusChartData?.JunCompleted,
            getSlaDashboardChecklistStatusChartData?.JulCompleted,
            getSlaDashboardChecklistStatusChartData?.AugCompleted,
            getSlaDashboardChecklistStatusChartData?.SepCompleted,
            getSlaDashboardChecklistStatusChartData?.OctCompleted,
            getSlaDashboardChecklistStatusChartData?.NovCompleted,
            getSlaDashboardChecklistStatusChartData?.DecCompleted
            ],
            backgroundColor: (context) => {
                const chart = context.chart;
                const ctx = chart.ctx;
                const gradient = ctx.createLinearGradient(0, 0, 0, chart.height);
                gradient.addColorStop(0, 'rgba(58, 201, 119, 0.2)');
                gradient.addColorStop(1, 'rgba(58, 201, 119, 0)');
                return gradient;
            },
            borderColor: 'rgba(58, 201, 119, 1)',
            borderWidth: 2,
            fill: true,
            tension: 0.4,
        },

    ];

    const ticketDetailsDatasets = [
        {
            type: 'bar',
            label: 'Target Value',
            data: [getSlaDashboardSlaTypesChartData?.JanTargetValueInPercentage,
            getSlaDashboardSlaTypesChartData?.FebTargetValueInPercentage,
            getSlaDashboardSlaTypesChartData?.MarTargetValueInPercentage,
            getSlaDashboardSlaTypesChartData?.AprTargetValueInPercentage,
            getSlaDashboardSlaTypesChartData?.MayTargetValueInPercentage,
            getSlaDashboardSlaTypesChartData?.JunTargetValueInPercentage,
            getSlaDashboardSlaTypesChartData?.JulTargetValueInPercentage,
            getSlaDashboardSlaTypesChartData?.AugTargetValueInPercentage,
            getSlaDashboardSlaTypesChartData?.SepTargetValueInPercentage,
            getSlaDashboardSlaTypesChartData?.OctTargetValueInPercentage,
            getSlaDashboardSlaTypesChartData?.NovTargetValueInPercentage,
            getSlaDashboardSlaTypesChartData?.DecTargetValueInPercentage
            ],
            backgroundColor: 'rgba(255, 94, 94, 1)', // Dark Red
            borderColor: 'rgba(255, 94, 94, 1)',
            borderWidth: 1,
            borderRadius: 4,
            barThickness: 8,
            borderSkipped: false,
        },
        {
            type: 'bar',
            label: 'Achieved Value',
            data: [getSlaDashboardSlaTypesChartData?.JanAchievedValueInPercentage,
            getSlaDashboardSlaTypesChartData?.FebAchievedValueInPercentage,
            getSlaDashboardSlaTypesChartData?.MarAchievedValueInPercentage,
            getSlaDashboardSlaTypesChartData?.AprAchievedValueInPercentage,
            getSlaDashboardSlaTypesChartData?.MayAchievedValueInPercentage,
            getSlaDashboardSlaTypesChartData?.JunAchievedValueInPercentage,
            getSlaDashboardSlaTypesChartData?.JulAchievedValueInPercentage,
            getSlaDashboardSlaTypesChartData?.AugAchievedValueInPercentage,
            getSlaDashboardSlaTypesChartData?.SepAchievedValueInPercentage,
            getSlaDashboardSlaTypesChartData?.OctAchievedValueInPercentage,
            getSlaDashboardSlaTypesChartData?.NovAchievedValueInPercentage,
            getSlaDashboardSlaTypesChartData?.DecAchievedValueInPercentage
            ],
            backgroundColor: 'rgba(58, 201, 119, 1)', // Bright Red
            borderColor: 'rgba(58, 201, 119, 1)',
            borderWidth: 1,
            borderRadius: 4,
            barThickness: 8,
            borderSkipped: false,
        }
    ];

    const chartOptions = {
        responsive: true,
        plugins: {
            tooltip: {
                callbacks: {
                    label: function (context) {
                        let label = context.dataset.label || '';
                        if (label) {
                            label += ': ';
                        }
                        if (context.parsed.y !== null) {
                            label += `${context.parsed.y}`;
                        }
                        return label;
                    }
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    stepSize: 25,
                    callback: function (value) {
                        if (value === 0 || value === 25 || value === 50 || value === 75 || value === 100) {
                            return value;
                        }
                    }
                }
            },
            y: {
                beginAtZero: true
            }
        }
    };
    const dropdownOptions = {
        company: {
            default: 'Company Name',
            // items: [
            //     { value: 'Company Name', label: 'Company Name' },
            //     { value: 'Other Company', label: 'Other Company' },
            // ],
            items: getCompanyDropdown,
        },
        assignedTo: {
            default: 'Assigned To',
            // items: [
            //     { value: 'Assigned To1', label: 'Assigned To1' },
            //     { value: 'Assigned To2', label: 'Assigned To2' },
            // ],
            items: reportingToDropdown,
        },
        slaType: {
            default: 'Select Type',
            // items: [
            //     { value: 'Select Type1', label: 'Select Type1' },
            //     { value: 'Select Type2', label: 'Select Type2' },
            // ],
            items: assignedToSlaTypeDropdownData,
        },

        year: {
            default: 'Year',
            // items: [
            //     { value: '2023', label: '2023' },
            //     { value: '2024', label: '2024' },
            // ],
            items: generateYearRange(2022),
        },
    };

    const branchDropdownOptions = {
        company: {
            default: 'Company Name',
            items: [
                { value: 'Company Name', label: 'Company Name' },
                { value: 'Other Company', label: 'Other Company' },
            ],
        },
        assignedTo: {
            default: 'Assigned To',
            items: [
                { value: 'Assigned To1', label: 'Assigned To1' },
                { value: 'Assigned To2', label: 'Assigned To2' },
            ],
        },
        selectType: {
            default: 'Select Type',
            items: [
                { value: 'Select Type1', label: 'Select Type1' },
                { value: 'Select Type2', label: 'Select Type2' },
            ],
        },

        year: {
            default: 'Year',
            items: [
                { value: '2023', label: '2023' },
                { value: '2024', label: '2024' },
            ],
        },
    };

    const funnelColors = ['rgba(240, 207, 43, 1)', 'rgba(255, 94, 0, 1)', 'rgba(58, 201, 119, 1)'];
    const funnelLabels = ['Hold', 'Inprocess', 'Completed'];
    const funnelData = [
        { value: 200 },
        { value: 150 },
        { value: 100 },
    ];

    const handleBack = () => {
        navigate(-1);
    };

    const handleNavigation = () => {
        navigate('/sla')
    }

    const slaTypeBarChartRef = useRef(null);
    const assignedScoreChartRef = useRef(null);
    const totalSlaFunnelChartRef = useRef(null);
    const slaTypeStatusBarChartRef = useRef(null);
    const slaCheckListBarChartRef = useRef(null);

    const handleDownloadExcel = () => {
        slaTypeBarChartRef.current.handleDownloadExcel();
        assignedScoreChartRef.current.handleDownloadExcel();
        totalSlaFunnelChartRef.current.handleDownloadExcel();
        slaTypeStatusBarChartRef.current.handleDownloadExcel();
        slaCheckListBarChartRef.current.handleDownloadExcel();
    }

    const handleDownloadPDF = () => {
        slaTypeBarChartRef.current.handleDownloadPDF();
        assignedScoreChartRef.current.handleDownloadPDF();
        totalSlaFunnelChartRef.current.handleDownloadPDF();
        slaTypeStatusBarChartRef.current.handleDownloadPDF();
        slaCheckListBarChartRef.current.handleDownloadPDF();
    }

    const handleDownloadWord = () => {
        slaTypeBarChartRef.current.handleDownloadWord();
        assignedScoreChartRef.current.handleDownloadWord();
        totalSlaFunnelChartRef.current.handleDownloadWord();
        slaTypeStatusBarChartRef.current.handleDownloadWord();
        slaCheckListBarChartRef.current.handleDownloadWord();
    }

    const handlePrint = () => {
        slaTypeBarChartRef.current.handlePrint();
        assignedScoreChartRef.current.handlePrint();
        totalSlaFunnelChartRef.current.handlePrint();
        slaTypeStatusBarChartRef.current.handlePrint();
        slaCheckListBarChartRef.current.handlePrint();
    }

    const handleDownloadImage = () => {
        slaTypeBarChartRef.current.handleDownloadImage();
        assignedScoreChartRef.current.handleDownloadImage();
        totalSlaFunnelChartRef.current.handleDownloadImage();
        slaTypeStatusBarChartRef.current.handleDownloadImage();
        slaCheckListBarChartRef.current.handleDownloadImage();
    }

    return (
        <div className='dashboard-container'>
            <Main>
                <div className='components-download-container'>
                    <Download moduleName="Service Level Agreement Dashboard"
                        showBackButton={true}
                        showDashboardLibraryButton={true}
                        showSaveCustomViewButton={true}
                        showAnalyticsButton={false}
                        showDownloadDropdown={true}
                        onBackClick={handleBack}
                        onExcelDownloadClick={handleDownloadExcel}
                        onPdfDownloadClick={handleDownloadPDF}
                        onWordDownloadClick={handleDownloadWord}
                        onPrintClick={handlePrint}
                        onImageClick={handleDownloadImage}
                    />
                </div>
                <Row className='dashboard-cards-container'>
                    <Col md={3} className='p-0 dashboard-cards-cols'>
                        <div className='dashboard-cards' onClick={handleNavigation}>
                            <div className='dashboard-cards-counts'>
                                <p>Total SLA</p>
                                <b>{loading ? <Skeleton width={100} /> : getSlaDashboardCardData.TotalSLAs}</b>
                            </div>
                            <div className='dashboard-cards-image'>
                                <img src={totalSla} alt="" />
                            </div>
                        </div>
                    </Col>
                    <Col md={3} className='pe-0 dashboard-cards-cols'>
                        <div className='dashboard-cards' onClick={handleNavigation}>
                            <div className='dashboard-cards-counts'>
                                <p>In-Process</p>
                                <b>{loading ? <Skeleton width={100} /> : getSlaDashboardCardData.InProcessSLAs}</b>
                            </div>
                            <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(255, 94, 94, 0.2)" }}>
                                <img src={inProcess} alt="" />
                            </div>
                        </div>
                    </Col>
                    <Col md={3} className='pe-0 dashboard-cards-cols'>
                        <div className='dashboard-cards' onClick={handleNavigation}>
                            <div className='dashboard-cards-counts'>
                                <p>Hold</p>
                                <b>{loading ? <Skeleton width={100} /> : getSlaDashboardCardData.OnHoldSLAs}</b>
                            </div>
                            <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(255, 159, 0, 0.2)" }}>
                                <img src={hold} alt="" />
                            </div>
                        </div>
                    </Col>
                    <Col md={3} className='pe-0 dashboard-cards-cols'>
                        <div className='dashboard-cards' onClick={handleNavigation}>
                            <div className='dashboard-cards-counts'>
                                <p>Completed</p>
                                <b>{loading ? <Skeleton width={100} /> : getSlaDashboardCardData.CompletedSLAs}</b>
                            </div>
                            <div className='dashboard-cards-image' style={{ backgroundColor: "rgba(58, 201, 119, 0.2)" }}>
                                <img src={completed} alt="" />
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row className='dashboard-charts'>
                    <Col md={6} className='dashboard-charts-div p-0 '>
                        <div className='charts-container'>
                            <AttendanceStatusChart
                                moduleName="SLA Types"
                                labels={ComplaintLabels}
                                datasets={ticketDetailsDatasets}
                                dropdownOptions={dropdownOptions}
                                selectedOption={selectedOptionForSlaType}
                                handleSelect={(eventKey, type) => handleSelect(eventKey, type, 'SlaTypes')}
                                // defaultSelection={{ company: 'Company Name', year: 'Year' }}
                                ref={slaTypeBarChartRef}
                            />
                        </div>
                    </Col>
                    <Col md={3} className='dashboard-charts-div p-0 '>
                        <div className='charts-container'>
                            <RelationshipTypeChart
                                moduleName="Assigned Score"
                                labels={labels}
                                colors={colors}
                                data={data}
                                showYear={true}
                                showAssignedTo={true}
                                showCompany={true}
                                ref={assignedScoreChartRef}
                            />
                        </div>
                    </Col>
                    <Col md={3} className='dashboard-charts-div p-0 pe-4'>
                        <div style={{ height: "100%" }}>
                            <FunnelChart
                                moduleName="Total SLA" colors={funnelColors} labels={funnelLabels} data={funnelData} ref={totalSlaFunnelChartRef}
                            />
                        </div>
                    </Col>
                </Row>
                <Row className='dashboard-charts pt-4 pb-4'>
                    <Col md={6} className='dashboard-charts-div p-0'>
                        <div className='charts-container'>
                            <AttendanceStatusChart
                                moduleName="SLA Type Status"
                                labels={ComplaintLabels}
                                datasets={datasets}
                                dropdownOptions={dropdownOptions}
                                selectedOption={selectedOptionForSlaTypeStatus}
                                handleSelect={(eventKey, type) => handleSelect(eventKey, type, 'SlaTypesStatus')}
                                // defaultSelection={{ ticketType: 'Ticket Type', company: 'Company Name', year: 'Year' }}
                                ref={slaTypeStatusBarChartRef}
                            />
                        </div>
                    </Col>
                    <Col md={6} className='dashboard-charts-div p-0 pe-2'>
                        <div className='charts-container'>
                            <AttendanceStatusChart
                                moduleName="SLA Checklist Status"
                                labels={ComplaintLabels}
                                datasets={datasetsOfSlaChecklistStatus}
                                dropdownOptions={dropdownOptions}
                                selectedOption={selectedOptionForSlaChecklistStatus}
                                handleSelect={(eventKey, type) => handleSelect(eventKey, type, 'SlaChecklistStatus')}
                                // defaultSelection={{ company: 'Company Name', year: 'Year' }}
                                ref={slaCheckListBarChartRef}
                            />
                        </div>
                    </Col>
                </Row>
            </Main>
        </div>
    )
}

export default ServiceLevelAgreementDashboard;

